const LIST_OF_TIMEZONES = Intl.supportedValuesOf('timeZone');

export default LIST_OF_TIMEZONES;
